import React from 'react';
import type { MeetingCheckTemplate, AiManager } from '../types/meeting';

interface SettingsPageProps {
  isOpen: boolean;
  onClose: () => void;
  meetingName: string;
  onMeetingNameChange: (name: string) => void;
  scheduledDurationMinutes: number;
  onScheduledDurationChange: (minutes: number) => void;
  customGoalText: string;
  onCustomGoalChange: (text: string) => void;
  aiManagers: AiManager[];
  selectedTemplateId: number | null;
  templates: MeetingCheckTemplate[];
  onShowAiManagerSelection: () => void;
  onShowMasterPage: () => void;
  onStartAiAssistant: () => void;
  companyId?: string;
  companyName?: string;
}

const SettingsPage: React.FC<SettingsPageProps> = ({
  isOpen,
  onClose,
  meetingName,
  onMeetingNameChange,
  scheduledDurationMinutes,
  onScheduledDurationChange,
  customGoalText,
  onCustomGoalChange,
  aiManagers,
  selectedTemplateId,
  templates,
  onShowAiManagerSelection,
  onShowMasterPage,
  onStartAiAssistant,
  companyId,
  companyName,
}) => {
  const activeManagerCount = aiManagers.filter((m) => m.active !== false).length;
  const selectedTemplate = templates.find((t) => t.id === selectedTemplateId);

  return (
    <div className={`page settings-page ${isOpen ? 'active' : ''}`} id="settings-page">
      <div className="page-header settings-header">
        <div className="back-button material-symbols-outlined" onClick={onClose}>
          arrow_back
        </div>
        <div className="page-title settings-title">
          会議設定
          {companyId && companyName && (
            <span
              style={{
                fontSize: '12px',
                color: '#888',
                marginLeft: '8px',
                fontWeight: 'normal',
              }}
            >
              企業ID: {companyId} - {companyName}
            </span>
          )}
        </div>
      </div>
      <div className="page-content settings-content">
        {/* 会議名 */}
        <div className="settings-section">
          <div className="settings-section-title">
            <span className="material-symbols-outlined">event</span>
            会議名
          </div>
          <input
            type="text"
            className="settings-input"
            id="meeting-name-input"
            placeholder="例: 週次定例会議"
            value={meetingName}
            onChange={(e) => onMeetingNameChange(e.target.value)}
          />
        </div>

        {/* 会議の予定時間 */}
        <div className="settings-section">
          <div className="settings-section-title">
            <span className="material-symbols-outlined">schedule</span>
            会議の予定時間
          </div>
          <select
            className="settings-input"
            id="scheduled-duration-select"
            value={scheduledDurationMinutes}
            onChange={(e) => onScheduledDurationChange(parseInt(e.target.value))}
          >
            <option value="30">30分</option>
            <option value="60">60分（1時間）</option>
            <option value="90">90分（1時間30分）</option>
            <option value="120">120分（2時間）</option>
            <option value="150">150分（2時間30分）</option>
            <option value="180">180分（3時間）</option>
          </select>
        </div>

        {/* 目的・ゴール */}
        <div className="settings-section">
          <div className="settings-section-title">
            <span className="material-symbols-outlined">flag</span>
            目的・ゴール
          </div>
          <textarea
            id="meeting-goal-textarea"
            className="settings-textarea"
            placeholder="目的・ゴールを入力してください"
            value={customGoalText}
            onChange={(e) => onCustomGoalChange(e.target.value)}
            rows={3}
          />
          <div className="settings-hint">マスターから選択するか、自由に編集できます</div>
        </div>

        {/* その他の設定 */}
        <div className="settings-section">
          <div className="settings-section-title">
            <span className="material-symbols-outlined">category</span>
            AI設定
          </div>
          <div className="settings-hub-container">
            {/* AIマネージャー */}
            <div className="settings-hub-item" onClick={onShowAiManagerSelection}>
              <div className="settings-hub-icon-wrapper">
                <span className="material-symbols-outlined settings-hub-icon">psychology</span>
              </div>
              <div className="settings-hub-info">
                <div className="settings-hub-title">AIマネージャー</div>
                <div className="settings-hub-desc" id="settings-ai-manager-summary">
                  {activeManagerCount}人が参加中
                </div>
              </div>
              <span className="material-symbols-outlined settings-hub-arrow">chevron_right</span>
            </div>

            {/* MTGチェックマスタ */}
            <div className="settings-hub-item" onClick={onShowMasterPage}>
              <div className="settings-hub-icon-wrapper">
                <span className="material-symbols-outlined settings-hub-icon">checklist</span>
              </div>
              <div className="settings-hub-info">
                <div className="settings-hub-title">MTGチェック</div>
                <div className="settings-hub-desc" id="settings-template-summary">
                  {selectedTemplate?.template_name || '未選択'}
                </div>
              </div>
              <span className="material-symbols-outlined settings-hub-arrow">chevron_right</span>
            </div>
          </div>
        </div>

        {/* AIアシスタント開始ボタン */}
        <div className="settings-section">
          <button className="btn-primary btn-full-width" onClick={onStartAiAssistant}>
            <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>
              play_arrow
            </span>
            AIアシスタント開始
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;

